import * as yup from "yup"
import { i18n } from "@lingui/core"

yup.setLocale({
	mixed: {
		required: i18n._(
			/*i18n*/ {
			id: "forms.field_required",
			message: "Il campo è obbligatorio",
			comment: "Generic validations, required field message",
		}),
		notType: i18n._(
			/*i18n*/ {
			id: "forms.wrong_format",
			message: "Formato non valido",
			comment: "Generic validations, format not valid",
		}),
	},
	array: {
		max: ({max}) => i18n._(
			/*i18n*/ {
			id: "forms.too_many_items",
			message: "Troppi elementi selezionati, max {max}",
			comment: "Array validations, too many items",
			values: {
				max: max,
			},
		}),
		min: ({min}) => i18n._(
			/*i18n*/ {
			id: "forms.too_few_items",
			message: "Il campo è obbligatorio",
			comment: "Array validations, too few items",
			values: {
				min: min,
			},
		}),
	},
	string: {
		email: i18n._(
			/*i18n*/ {
			id: "forms.email_wrong_format",
			message: "Non hai inserito un indirizzo valido",
			comment: "Generic validations, email wrong format message",
		}),
		length: ({length}) => i18n._(
			/*i18n*/ {
			id: "forms.wrong_length",
			message: "Inserisci {length} caratteri",
			comment: "Generic validations, wrong length message",
			values: {
				length: length,
			},
		}),
		matches: i18n._(
			/*i18n*/ {
			id: "forms.wrong_format",
			message: "Formato non valido",
			comment: "Generic validations, format not valid",
		}),
		max: ({max}) => i18n._(
			/*i18n*/ {
			id: "forms.too_many_characters",
			message: "Troppi caratteri, max {max}",
			comment: "Generic validations, too many characters",
			values: {
				max: max,
			},
		}),
		min: ({min}) => i18n._(
			/*i18n*/ {
			id: "forms.too_few_characters",
			message: "Troppi pochi caratteri, min {min}",
			comment: "Generic validations, too few characters",
			values: {
				min: min,
			},
		}),
	},
	date: {
		min: i18n._(
			/*i18n*/ {
			id: "forms.date_min_value",
			message: "La data inserita non è valida",
			comment: "Date min validations, date",
		}),
		max: i18n._(
			/*i18n*/ {
			id: "forms.date_minììax_value",
			message: "La data inserita non è valida",
			comment: "Date max validations, date",
		}),
	},
	number: {
		integer: i18n._(
			/*i18n*/ {
			id: "forms.number_integer",
			message: "Inserire solo numeri interi",
			comment: "Validation requires an integer number",
		}),
		positive: i18n._(
			/*i18n*/ {
			id: "forms.number_positive",
			message: "Inserire solo numeri maggiori di zero",
			comment: "Validation requires an integer number",
		}),
		min: ({min}) => i18n._(
			/*i18n*/ {
			id: "forms.number_min",
			message: "Inserisci un numero superiore a {min}",
			comment: "Number validation, value is lower than min",
			values: {
				min: min,
			},
		}),
		max: ({max}) => i18n._(
			/*i18n*/ {
			id: "forms.number_max",
			message: "Inserisci un numero inferiore a {max}",
			comment: "Number validation, value is greater than max",
			values: {
				max: max,
			},
		}),
	}
})

yup.addMethod(
	yup.string,
	"email",
	function validateEmail(message)
	{
		return this.matches(/.+@.+\..+/, {
			message,
			name: "email",
			excludeEmptyString: true,
		})
	}
)
